<div *ngIf="usuariosAdmin.length > 0" class="flex flex-col">
  <div class="overflow-x-hidden">
    <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Status
              </th>
              <th scope="col" class="px-2 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Nome
              </th>
              <th scope="col" class="px-2 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                E-mail
              </th>
              <th scope="col" class="px-2 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Empresa
              </th>
              <th
                scope="col"
                class="px-2 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'adminuser.update']"
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let usuario of usuariosAdmin">
              <td class="px-6 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                <app-status-switch
                  [active]="usuario.active"
                  [itemName]="'usuário ' + usuario.fullName"
                  [enablePermissions]="[ERoleAdminString.Admin, 'adminuser.enable']"
                  [disablePermissions]="[ERoleAdminString.Admin, 'adminuser.disable']"
                  (toggle)="toogleUsuarioAdminStatus(usuario.id!, usuario.active!)"
                ></app-status-switch>
              </td>
              <td class="px-3 py-4 pl-0 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ usuario.fullName }}
              </td>
              <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ usuario.email }}
              </td>
              <td class="px-3 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ usuario.company?.name }}
              </td>
              <td
                class="flex justify-center flex-1 gap-2 px-3 py-4 whitespace-normal text-md text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'adminuser.update']"
              >
                <a
                  *isAllowed="[ERoleAdminString.Admin, 'adminuser.update']"
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  [routerLink]="'editar/' + usuario.id"
                  [attr.aria-label]="'Editar usuário ' + usuario.fullName"
                  [title]="'Editar usuário ' + usuario.fullName"
                >
                  <lucide-icon name="pencil" [size]="18"></lucide-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-no-results-found [condition]="usuariosAdmin.length === 0"></app-no-results-found>
<div class="flex justify-end mb-5">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
